import React from "react";
import { DEFAULT_FONT_FAMILY, FONT_FAMILY_TYPE } from "../../../gen2_widgets/schemaHelpers.js";
import TextSetting from "./TextSetting.jsx";
import SliderSetting from "../../common/SliderSetting.jsx";
import SelectSetting from "../../common/SelectSetting.jsx";
import ColorPickerSetting from "./ColorPickerSetting.jsx";
import SettingsSection from "../../common/SettingsSection.jsx";

function TextStyleOptions(props) {
  const { includeText = true, additionalSettings = null, defaultColor = '#FFFFFF', defaultFontSize = 12 } = props;

  return (
    <SettingsSection>
      {includeText && <TextSetting attr='text' label={I18n.t('text')} {...props} />}
      <SliderSetting attr='fontSize' label={I18n.t('font_size')} {...props} defaultValue={defaultFontSize}/>
      <SelectSetting attr='fontFamily' label={I18n.t('font_family')} {...props} options={FONT_FAMILY_TYPE.enum.map((o) => ({value: o, label: o}))} defaultValue={DEFAULT_FONT_FAMILY} />
      <ColorPickerSetting attr='color' label={I18n.t('color')} {...props} defaultValue={defaultColor} />
      {additionalSettings}
    </SettingsSection>
  )
}

export default TextStyleOptions;